var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundingCalanderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 77,
    viewBox: "0 0 73 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4371_64571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4791 17.602V13.832C45.4791 12.8412 44.6574 12.0195 43.6666 12.0195C42.6757 12.0195 41.8541 12.8412 41.8541 13.832V17.457H26.1457V13.832C26.1457 12.8412 25.3241 12.0195 24.3332 12.0195C23.3424 12.0195 22.5207 12.8412 22.5207 13.832V17.602C15.9957 18.2062 12.8299 22.097 12.3466 27.8729C12.2982 28.5737 12.8782 29.1537 13.5549 29.1537H54.4449C55.1457 29.1537 55.7257 28.5495 55.6532 27.8729C55.1699 22.097 52.0041 18.2062 45.4791 17.602Z",
    fill: "url(#paint0_linear_4371_64571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9167 45.25C45.5758 45.25 41.25 49.5758 41.25 54.9167C41.25 56.7292 41.7575 58.445 42.6517 59.895C44.3192 62.6983 47.3883 64.5833 50.9167 64.5833C54.445 64.5833 57.5142 62.6983 59.1817 59.895C60.0758 58.445 60.5833 56.7292 60.5833 54.9167C60.5833 49.5758 56.2575 45.25 50.9167 45.25ZM55.9192 53.8775L50.7717 58.6383C50.4333 58.9525 49.9742 59.1217 49.5392 59.1217C49.08 59.1217 48.6208 58.9525 48.2583 58.59L45.8658 56.1975C45.165 55.4967 45.165 54.3367 45.8658 53.6358C46.5667 52.935 47.7267 52.935 48.4275 53.6358L49.5875 54.7958L53.4542 51.2192C54.1792 50.5425 55.3392 50.5908 56.0158 51.3158C56.6925 52.0408 56.6442 53.1767 55.9192 53.8775Z",
    fill: "url(#paint1_linear_4371_64571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9192 53.8775L50.7717 58.6383C50.4333 58.9525 49.9742 59.1217 49.5392 59.1217C49.08 59.1217 48.6208 58.9525 48.2583 58.59L45.8658 56.1975C45.165 55.4967 45.165 54.3367 45.8658 53.6358C46.5667 52.935 47.7267 52.935 48.4275 53.6358L49.5875 54.7958L53.4542 51.2192C54.1792 50.5425 55.3392 50.5908 56.0158 51.3158C56.6925 52.0408 56.6442 53.1767 55.9192 53.8775Z",
    fill: "#20302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3333 32.7812H14.6667C13.3375 32.7812 12.25 33.8687 12.25 35.1979V50.0846C12.25 57.3346 15.875 62.1679 24.3333 62.1679H36.2475C37.915 62.1679 39.075 60.5487 38.5433 58.9779C38.06 57.5762 37.6492 56.0296 37.6492 54.9179C37.6492 47.5954 43.6183 41.6262 50.9408 41.6262C51.6417 41.6262 52.3425 41.6746 53.0192 41.7954C54.4692 42.0129 55.7742 40.8771 55.7742 39.4271V35.2221C55.75 33.8688 54.6625 32.7812 53.3333 32.7812ZM27.2575 53.0087C26.7983 53.4437 26.17 53.7096 25.5417 53.7096C24.9133 53.7096 24.285 53.4437 23.8258 53.0087C23.3908 52.5496 23.125 51.9212 23.125 51.2929C23.125 50.6646 23.3908 50.0363 23.8258 49.5771C24.0675 49.3596 24.3092 49.1904 24.6233 49.0696C25.5175 48.6829 26.5808 48.9004 27.2575 49.5771C27.6925 50.0363 27.9583 50.6646 27.9583 51.2929C27.9583 51.9212 27.6925 52.5496 27.2575 53.0087ZM27.2575 44.5504C27.1367 44.6471 27.0158 44.7437 26.895 44.8404C26.75 44.9371 26.605 45.0096 26.46 45.0579C26.315 45.1304 26.17 45.1787 26.025 45.2029C25.8558 45.2271 25.6867 45.2512 25.5417 45.2512C24.9133 45.2512 24.285 44.9854 23.8258 44.5504C23.3908 44.0912 23.125 43.4629 23.125 42.8346C23.125 42.2062 23.3908 41.5779 23.8258 41.1187C24.3817 40.5629 25.2275 40.2971 26.025 40.4663C26.17 40.4904 26.315 40.5387 26.46 40.6112C26.605 40.6596 26.75 40.7321 26.895 40.8287C27.0158 40.9254 27.1367 41.0221 27.2575 41.1187C27.6925 41.5779 27.9583 42.2062 27.9583 42.8346C27.9583 43.4629 27.6925 44.0912 27.2575 44.5504ZM35.7158 44.5504C35.2567 44.9854 34.6283 45.2512 34 45.2512C33.3717 45.2512 32.7433 44.9854 32.2842 44.5504C31.8492 44.0912 31.5833 43.4629 31.5833 42.8346C31.5833 42.2062 31.8492 41.5779 32.2842 41.1187C33.2025 40.2246 34.8217 40.2246 35.7158 41.1187C36.1508 41.5779 36.4167 42.2062 36.4167 42.8346C36.4167 43.4629 36.1508 44.0912 35.7158 44.5504Z",
    fill: "url(#paint2_linear_4371_64571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2575 44.5504L26.895 44.8404C26.75 44.9371 26.605 45.0096 26.46 45.0579C26.315 45.1304 26.17 45.1787 26.025 45.2029C25.8558 45.2271 25.6867 45.2512 25.5417 45.2512C24.9133 45.2512 24.285 44.9854 23.8258 44.5504C23.3908 44.0912 23.125 43.4629 23.125 42.8346C23.125 42.2062 23.3908 41.5779 23.8258 41.1187C24.3817 40.5629 25.2275 40.2971 26.025 40.4663C26.17 40.4904 26.315 40.5387 26.46 40.6112C26.605 40.6596 26.75 40.7321 26.895 40.8287L27.2575 41.1187C27.6925 41.5779 27.9583 42.2062 27.9583 42.8346C27.9583 43.4629 27.6925 44.0912 27.2575 44.5504Z",
    fill: "#20302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7158 44.5504C35.2567 44.9854 34.6283 45.2512 34 45.2512C33.3717 45.2512 32.7433 44.9854 32.2842 44.5504C31.8492 44.0912 31.5833 43.4629 31.5833 42.8346C31.5833 42.2062 31.8492 41.5779 32.2842 41.1187C33.2025 40.2246 34.8217 40.2246 35.7158 41.1187C36.1508 41.5779 36.4167 42.2062 36.4167 42.8346C36.4167 43.4629 36.1508 44.0912 35.7158 44.5504Z",
    fill: "#20302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2575 53.0087C26.7983 53.4437 26.17 53.7096 25.5417 53.7096C24.9133 53.7096 24.285 53.4437 23.8258 53.0087C23.3908 52.5496 23.125 51.9212 23.125 51.2929C23.125 50.6646 23.3908 50.0363 23.8258 49.5771C24.0675 49.3596 24.3092 49.1904 24.6233 49.0696C25.5175 48.6829 26.5808 48.9004 27.2575 49.5771C27.6925 50.0363 27.9583 50.6646 27.9583 51.2929C27.9583 51.9212 27.6925 52.5496 27.2575 53.0087Z",
    fill: "#20302F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4371_64571",
    x: -7,
    y: -3,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.533333 0 0 0 0 0.890196 0 0 0 0 0.866667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4371_64571"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4371_64571",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4371_64571",
    x1: 26.4213,
    y1: 12.0195,
    x2: 17.4212,
    y2: 73.7364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D6366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4371_64571",
    x1: 47.5333,
    y1: 45.25,
    x2: 60.7692,
    y2: 70.3462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D6366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4371_64571",
    x1: 26.3954,
    y1: 32.7812,
    x2: 39.2871,
    y2: 82.7954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D6366"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundingCalanderIcon);
export default __webpack_public_path__ + "static/media/funding-calander-icon.fc83e085a7ec438d19feeba51ee2982a.svg";
export { ForwardRef as ReactComponent };